/* eslint-disable */
import { useParameter, useExport } from "../../../shared";
import * as React from "react";

export function useExportQuery(title, subtitle) {
  const exportBuilder = useExport();
  const [commodities] = useParameter<number[]>("@commodities");
  const [units] = useParameter<number[]>("@units");
  const [calendar] = useParameter<number[]>("@calendar");
  const [commoditiesDisplay] = useParameter<number[]>("@commodities_display");

  React.useEffect(() => {
    exportBuilder.set('title', title);
    exportBuilder.set('subtitle', subtitle);
    exportBuilder.set('reportDefinition', {
      reportId: exportBuilder.reportId,
      name: { 9: title },
      parameters: {
        "@commodities": commodities?.map(String),
        "@commodities_display": commoditiesDisplay?.map(String),
        "@calendar": calendar?.map(String),
        "@units": units?.map(String),
      }
    });
  }, [title, subtitle, exportBuilder, calendar, units, calendar, commodities, commoditiesDisplay]);
}

